export const ADD = 'TOASTS_ACTIONS_ADD';
export const REMOVE = 'TOASTS_ACTIONS_REMOVE';
